import React from "react";
import ReactDOM from "react-dom";
import { WishListLoader } from "./wish-list-loader";

let wishListLoaderWrapper;

export const unmount = () => {
  if (!wishListLoaderWrapper) {
    return;
  }
  ReactDOM.unmountComponentAtNode(wishListLoaderWrapper);
};

export default () => {
  wishListLoaderWrapper = document.querySelector("#wish-list-loader-wrapper");
  if (!wishListLoaderWrapper) {
    return;
  }

  return ReactDOM.render(
    <WishListLoader
      sku={wishListLoaderWrapper.getAttribute("data-sku")}
      skuSelected={wishListLoaderWrapper.getAttribute("data-sku-selected")}
      dataProductDetails={wishListLoaderWrapper.getAttribute("data-product-details")}
    />,
    wishListLoaderWrapper
  );
}
